var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.65,
    height: 121.343,
    viewBox: "0 0 145.65 121.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1102",
    "data-name": "Raggruppa 1102",
    transform: "translate(-252.64 -135.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_638",
    "data-name": "Raggruppa 638",
    transform: "translate(252.64 135.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_637",
    "data-name": "Raggruppa 637",
    transform: "translate(48.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4069",
    "data-name": "Tracciato 4069",
    d: "M300.137,141.11l-10.362,10.36L333.3,194.994c6.307,6.307,16.592,7.516,23.5,1.868a17.056,17.056,0,0,0,1.307-25.3L327.646,141.11A19.449,19.449,0,0,0,300.137,141.11Z",
    transform: "translate(-265.679 -135.411)",
    fill: "#1c395d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4070",
    "data-name": "Tracciato 4070",
    d: "M345.712,187.869,301.5,143.656l-18.4,18.4a19.449,19.449,0,0,0,0,27.509l30.456,30.458a17.051,17.051,0,0,1,0,24.114l12.058-12.056,32.154-32.154,12.058-12.058A17.053,17.053,0,0,1,345.712,187.869Z",
    transform: "translate(-277.403 -127.598)",
    fill: "#094795"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4071",
    "data-name": "Tracciato 4071",
    d: "M287.1,141.11l-28.76,28.758a19.455,19.455,0,0,0,0,27.511l53.887,53.885c6.307,6.307,16.592,7.516,23.495,1.87a17.055,17.055,0,0,0,1.307-25.3L306.57,197.378a19.449,19.449,0,0,1,0-27.509l18.4-18.4-10.36-10.36A19.452,19.452,0,0,0,287.1,141.11Zm-11.653,48.657a7.185,7.185,0,1,1,0-10.161A7.185,7.185,0,0,1,275.444,189.767Z",
    transform: "translate(-252.64 -135.411)",
    fill: "#3360ef"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/LoginLogo.98b4629eab268464e4768e177aedc81b.svg";
export { ForwardRef as ReactComponent };